import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions as modalActions } from '@gcloud-npm/next12.app-controller.reducers-sagas.modals-reducer';
import dynamic from 'next/dynamic';
import CustomLink from '@gcloud-npm/next12.components.custom-link';
import Image from '@gcloud-npm/next12.components.image-n';
import TextInfo from '@gcloud-npm/next12.components.text-info-n';
import Button from '@gcloud-npm/next12.components.button-m';
import Icon from '@gcloud-npm/next12.components.icon-n';
import useMediaQuery from '@/hooks/useMediaQuery';
import { c2cMock } from '@/constants/c2cMock';
import { getUrlAlias } from '../../utils/url.utils';
import FloatingPhoneNumber from '../FloatingPhoneNumber';
import Flotante from '../Flotante';

export const COMPONENT_NAME = 'SubHeader';
export const NAVIGATION_ITEMS_INDEX = {
  '': 0,
  kitconsulting: 1,
  bonopyme: 2,
  'entender-ayudas': 3,
  'experto-digital': 4,
  'digitalizacion-empresas': 5,
};

const ModalAtencionEmp = dynamic(() =>
  import('@/components/modal-atencion-emp')
);

const SubHeader = (props) => {
  const { data } = useSelector((state) => state.constants);
  const { call4selling, navigationItems, tipoEmpresa } = props;
  const { callMeBackSe } = call4selling;

  const [scrollY, setScrollY] = useState(0);
  const [isSliderSticky, setIsSliderSticky] = useState(false);
  const [isSliderHidden, setIsSliderHidden] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);

  const taggingInfo = {
    componentVariation: 'all',
    componentName: COMPONENT_NAME,
    componentProduct: '',
  };

  const dispatch = useDispatch();

  const getTabIndex = () => {
    let currentURL = '';
    if (typeof window !== 'undefined') {
      currentURL = window.location.href;
    }
    const alias = getUrlAlias(currentURL);
    let _tabIndex;
    if (alias) {
      _tabIndex = NAVIGATION_ITEMS_INDEX[alias];
    }
    if (typeof _tabIndex === 'undefined') {
      _tabIndex = 0;
    }
    return _tabIndex;
  };

  const colorSelectedText = (index) => {
    return tabIndex === index ? 'blue' : 'grey5';
  };

  useEffect(() => {
    const newTabIndex = getTabIndex();
    if (newTabIndex !== tabIndex) {
      setTabIndex(newTabIndex);
    }
  }, [tabIndex]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsSliderSticky(scrollPosition > 92);
      setIsSliderHidden(scrollPosition > 235 && scrollPosition > scrollY);
      setScrollY(scrollPosition);
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrollY]);

  const handleModal = ({ productModal, tab = 'te-llamamos' }) => {
    const MODAL_PROPS = {
      contentPosition: 'right--center',
      opacityLayoutColor: 'black05',
      inSceneEffect: 'faseInLeft',
      outSceneEffect: 'fadeOutRight',
      closeByClickingOutside: true,
      scrollAllowed: false,
    };
    dispatch(
      modalActions.addModal({
        id: 'atencionModal',
        type: 'MODAL',
        elementProps: {
          tabsOptions: {
            ...data.modalAtencionConfig,
            tabOptionPreChecked: tab,
          },
          product: `Interés ${productModal} BarraSuperior`,
          taggingInfo: {
            componentProduct: productModal,
            componentVariation: 'all',
            componentName: COMPONENT_NAME,
          },
        },
        Element2Show: ModalAtencionEmp,
        modalProps: MODAL_PROPS,
      })
    );
  };

  const isMobile = useMediaQuery('(max-width: 768px)');
  const isDesktop = useMediaQuery('(min-width: 1224px)');
  return (
    <>
      <section className="Subheader">
        <div
          className={`slider ${isSliderHidden ? 'hidden' : ''} ${
            isSliderSticky ? 'sticky' : ''
          }`}
        >
          <div className="sliderTop container">
            {navigationItems.map((item, index) => (
              <div className="tab">
                <CustomLink
                  taggingInfo={{
                    ...taggingInfo,
                    componentContent: `${item.title}`,
                  }}
                  forceExternal
                  href={item.url}
                >
                  <div
                    className={`title ${
                      colorSelectedText(index) === 'blue' ? 'underline' : ''
                    }`}
                  >
                    <TextInfo
                      {...props['TextInfo-2']}
                      text={item.title}
                      color={colorSelectedText(index)}
                    />
                  </div>
                </CustomLink>
              </div>
            ))}
            {isDesktop && (
              <Button
                {...callMeBackSe.buttonProps}
                onClick={() => {
                  handleModal({
                    productModal: 'Fondos Beneficios',
                  });
                }}
                taggingInfo={{
                  ...taggingInfo,
                  componentContent: 'te-asesoramos',
                }}
              />
            )}
          </div>
          {!isDesktop && tipoEmpresa !== 'autonomo' && (
            <div className="floatingPhoneNumer container">
              <FloatingPhoneNumber
                taggingInfo={{
                  ...taggingInfo,
                  componentContent: 'FloatingPhoneNumber',
                  componentName: 'Header',
                }}
                Icon={Icon}
                {...call4selling}
              />
            </div>
          )}
        </div>
        <div className="image">
          <div className="container">
            {isMobile ? (
              <Image
                src={`${process.env.NEXT_PUBLIC_CDN}/${props['Image-1'].picMobile.src}`}
                alt={props['Image-1'].alt}
                layout="responsive"
                width={522}
                height={397}
              />
            ) : (
              <Image
                src={`${process.env.NEXT_PUBLIC_CDN}/${props['Image-1'].picDesktop.src}`}
                alt={props['Image-1'].alt}
                layout="responsive"
                width={1201}
                height={109}
              />
            )}
          </div>
        </div>
        {tipoEmpresa !== 'autonomo' &&
          (!isMobile || (isMobile && isSliderHidden)) && (
            <Flotante {...c2cMock} product="Fondos Beneficios" />
          )}
      </section>
      <style jsx>
        {`
          .Subheader {
            .slider {
              z-index: 4;
              .sliderTop {
                height: 4rem;
                width: 25rem;
                display: flex;
                align-items: center;
                overflow-x: scroll;
                overscroll-behavior-x: contain;
                scroll-snap-type: x proximity;
                white-space: nowrap;
                .tab {
                  margin-right: 2rem;
                }
                .underline {
                  border-bottom: 0.125rem solid var(--color-emp--blue);
                  padding-bottom: 1rem;
                  margin-top: 1rem;
                }
              }
              .floatingPhoneNumer {
                position: fixed;
                bottom: 0;
                background: var(--color-emp--white);
                width: 100%;
                z-index: 4;
                padding: 1rem 0;
                justify-content: center;
                display: flex;
              }
            }
            .sticky {
              background-color: var(--color-emp--white);
              position: fixed;
              top: 0;
              left: 0;
              right: 0;
              z-index: 4;
            }
            .hidden {
              display: none;
            }
            .image {
              padding: 2rem 0;
              background-color: var(--color-emp--grey1);
            }
          }

          @media screen and (min-width: 769px) {
            .Subheader {
              .slider {
                .sliderTop {
                  height: 5rem;
                  width: auto;
                  flex-direction: row;
                  justify-content: space-between;
                  flex-wrap: wrap;
                  overflow-x: auto;
                }
              }
              .image {
                padding: 2rem 0 4rem;
              }
            }
          }
        `}
      </style>
    </>
  );
};

export default SubHeader;
